import { api } from "./api";

/**
 * COCO bulk payment endpoints.
 *
 * Both are parameterised by `slug` — "rent" or "sd" — which is the only thing
 * that differs between the two payment types at the transport level. The shared
 * `api` instance's baseURL already ends in /api, so paths start at /coco-store,
 * matching coco-store-overview-api.js.
 */

// Drops empty query params so the request URL carries only what was actually set.
function buildParams(obj) {
  const out = {};
  Object.keys(obj || {}).forEach((key) => {
    const value = obj[key];
    if (value === null || value === undefined || value === "") return;
    out[key] = value;
  });
  return out;
}

/**
 * POST /coco-store/payments/<slug>/bulk-upload
 *
 * Body is a bare JSON array of payment rows — not an object wrapper and not
 * multipart. The file itself is never sent; it is parsed in the browser and the
 * resulting rows are posted.
 */
export const bulkUploadPaymentsApi = ({ slug, rows }) =>
  api.post(`/coco-store/payments/${slug}/bulk-upload`, JSON.stringify(rows));

/** GET /coco-store/payments/<slug>/history */
export const paymentHistoryApi = ({
  slug,
  page,
  limit,
  search,
  search_column,
  payment_status,
  upload_from,
  upload_to,
  credited_from,
  credited_to,
  sortBy,
  sortOrder,
} = {}) =>
  api.get(`/coco-store/payments/${slug}/history`, {
    params: buildParams({
      page,
      limit,
      search,
      search_column,
      payment_status,
      upload_from,
      upload_to,
      credited_from,
      credited_to,
      sortBy,
      sortOrder,
    }),
  });
